module.exports = __webpack_public_path__ + "static/media/loose.033ff310.mp3";